import { ICompromizedPasswordStore } from '../compromized-password.store';
import { injectable } from '@servicetitan/react-ioc';

@injectable()
export class CompromizedPasswordStoreMock implements ICompromizedPasswordStore {
    isPasswordStrong = false;
    isValid = false;
    isValidating = false;
    validate = jest.fn();
}
